import { useCurShop, useToken } from '@/store'

// 根据token缓存
export default (fn: any, set: any, time?:number): any => {
  const cache: any = new Map()
  const req: any = {}
  let token = ''
  let curShop = ''
  let timeStamp: null | number = null
  return (...rest:any[]) => {
    const key = JSON.stringify(rest)
    const isOutTime = timeStamp && (timeStamp - new Date().getTime() < 0)
    if (cache.get(key) && token === useToken() && !isOutTime && curShop === useCurShop()) return Promise.resolve(cache.get(key))
    if (req[key]) return req[key]
    return (req[key] = fn(...rest).then((res: any) => {
      cache.set(key, res)
      token = useToken()
      curShop = useCurShop()
      if (time) {
        timeStamp = new Date().getTime() + time
      }
      req[key] = null
      return res
    }))
  }
}

// 定时更新
